export default {"src":"/_next/static/media/spotify-mono.ad73731f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};